<template>
  <div>
    <div class="mx-2 ustify-center">
      <v-card :loading="isLoading" class="mx-auto my-12" max-width="500">
        <v-img
          class="mx-auto my-12"
          height="150"
          width="150"
          src="@/assets/success.png"
        >
        </v-img>
        <v-card-title class="justify-center">تم استلام طلبكم بنجاح </v-card-title>
        <v-card-text>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>

export default {
  name: "RequestReceived",


  //********************** */
  components: {},

  //********************** */
  data: () => ({
    
  }),

  //********************** */
  computed: {

  },

  //********************** */
  methods: {
   
  },

  //*********************** */
  async mounted() {
   
  },
};
</script>

<style>
</style>